import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/logo3.svg";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/img/nav-icon4.svg';

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" id="iron-head"/>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
                <a href="https://www.linkedin.com/in/deepan-adak/"><img src={navIcon1} alt="linkedin" /></a>
                <a href="https://github.com/mr-prometheus"><img src={navIcon4} alt="github" /></a>
                <a href="https://www.instagram.com/deepan_adak/"><img src={navIcon3} alt="instagram" /></a>
            </div>
            <p>By-Deepan</p>
            <p>Copyright 2022. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
